/**
* @description This middleware is used to redirect the user to the login page if the user is not logged in. Used in the index page.
* @module middleware/loginRedirect
* @param {Object} to - The target Route Object being navigated to.
* @param {Object} from - The current route being navigated away from.
* @returns {Promise} - Returns a Promise that resolves to the path of the login page if the user is not logged in.
*/

import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app"
import { useUserStore } from "../store/user"

export default defineNuxtRouteMiddleware(async (to, from) => {
    const userStore = useUserStore()
    

    if (userStore.$state.token === '' && userStore.$state.password === '' && userStore.$state.userName === '') {
        console.log("login redirect")
        return navigateTo('/login')
    }
})